var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#4232A4",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.714 27.5c0 .534-.11 1.042-.331 1.523a3.768 3.768 0 0 1-.954 1.27v4.473l-2.572-1.25-2.571 1.25v-4.473A3.727 3.727 0 0 1 16 27.5c0-.514.1-1 .301-1.455.201-.456.476-.853.824-1.192a4.02 4.02 0 0 1 1.225-.81c.47-.202.971-.3 1.507-.293a3.852 3.852 0 0 1 3.546 2.295c.2.45.305.934.311 1.455zM19.857 30c.355 0 .687-.065.995-.195.308-.13.582-.31.823-.537.241-.228.425-.492.553-.791.127-.3.194-.625.2-.977 0-.345-.066-.667-.2-.967a2.658 2.658 0 0 0-.553-.8 2.408 2.408 0 0 0-.813-.538A2.808 2.808 0 0 0 19.857 25c-.355 0-.686.065-.994.195-.308.13-.583.31-.824.537a2.335 2.335 0 0 0-.552.791c-.128.3-.195.625-.201.977 0 .345.067.667.2.967.134.3.319.566.553.8.234.235.506.414.814.538.308.123.642.189 1.004.195zm1.286 1.035c-.409.143-.82.215-1.236.215-.468 0-.914-.072-1.336-.215v1.7l1.286-.626 1.286.625v-1.699zM34 20.361V35H23.714v-1.25h9v-12.5h-5.143v-5h-9v6.094a5.734 5.734 0 0 0-1.285.468V15h11.2L34 20.361zM31.8 20l-2.943-2.861V20H31.8z",
    fill: "#4232A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.b84f40b6ae5c43314cb98402be7bb8e6.svg";
export { ForwardRef as ReactComponent };